import { render, staticRenderFns } from "./AboutUsMobileView.vue?vue&type=template&id=0f90d562&scoped=true&"
import script from "./AboutUsMobileView.vue?vue&type=script&lang=js&"
export * from "./AboutUsMobileView.vue?vue&type=script&lang=js&"
import style0 from "./AboutUsMobileView.vue?vue&type=style&index=0&id=0f90d562&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f90d562",
  null
  
)

export default component.exports